import { useCallback } from 'react';

import {
  IModifierMultiplier,
  IModifierTypeUIProps,
} from 'features/menu/components/product-detail/modifier/types';
import { logProductModifierCustomization } from 'features/menu/components/product-detail/modifier/utils';

import { ListCardGroup } from 'components/list-card-group';
import { t } from 'state/intl/translations';

import { ModifierListItem } from './modifier-list-item';

export const ModifierSingleChoice: React.FC<IModifierTypeUIProps> = ({
  modifier,
  selections,
  onSelectionsChange,
}) => {
  const handleListItemPress = useCallback(
    (multiplier: IModifierMultiplier) => {
      onSelectionsChange({ [multiplier.id]: 1 });
      logProductModifierCustomization(multiplier.name, modifier.name, multiplier.id);
    },
    [onSelectionsChange, modifier]
  );

  return (
    <ListCardGroup
      isFullContainer
      header={t('chooseItemAmount', { amount: modifier.quantity.max, itemName: modifier.name })}
      items={modifier.multipliers}
      renderItem={({ item: multiplier }: { item: IModifierMultiplier }) => (
        <ModifierListItem
          key={multiplier.id}
          isSelected={!!selections[multiplier.id]}
          onCardPress={handleListItemPress}
          itemValue={multiplier}
          content={multiplier}
        />
      )}
    />
  );
};
